import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

export default function free3Box(props) {
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a, b, c,d) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    //let conver_current_s = (parseInt(props.currentSlide));
    //alert('2242421414122== ' + conver_current_s);
    let contentId;
    let contentTitle;
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '상단영역_자유형(3개)',
        clickType: 'NC',
        value1: b.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  return (

    <div className="swiper-slide slide-slide">
      <div className="swiper-cont">
        <div className="spotModuleGroup">

          {/* <!-- 자유형 : type1 : 포토 높이 반 --> */}
          <div className={`spotModuleWrap_freeType1-1 spotModuleWrap_ContentPhoto ${props.data.contents[0].title == '' || props.data.contents[0].title == null ? 'spotModuleWrap_freeTypeBnr' : ''}`}>
            {props.data.contents[0].link_url == null || props.data.contents[0].link_url == ''
              ? (
                <>
                  <div className="spotModuleLink">
                    <span className="spotModuleImage_w">
                      <img src={props.data.contents[0].m_img_url}
                        className="spotModuleImg" alt={props.data.contents[0].m_img_attr} />
                      {/* <Image
                      src={props.data.contents[0].m_img_url}
                      className="spotModuleImg"
                      layout='fixed'
                      width={335}
                      height={121}
                      quality={props.data.contents[0].imageQuality || 75}
                      alt={props.data.contents[0].m_img_attr}
                    /> */}
                    </span>
                    <div className="spotProgramCont">
                      <strong className="spotProgram-Title">{props.data.contents[0].title}</strong>
                    </div>
                  </div>
                </>
              )
              :
              (
                <>
                  <a href={props.data.contents[0].link_url} >
                    <a onClick={(e) => handleClick(e, props.data.contents[0], '3free','1')} target={props.data.contents[0].link_new_yn === 'Y' ? '_blank' : ''} className="spotModuleLink">
                      <span className="spotModuleImage_w">
                        <img src={props.data.contents[0].m_img_url}
                          className="spotModuleImg" alt={props.data.contents[0].m_img_attr} />
                        {/* <Image
                    src={props.data.contents[0].m_img_url}
                    className="spotModuleImg"
                    layout='fixed'
                    width={335}
                    height={121}
                    quality={props.data.contents[0].imageQuality || 75}
                    alt={props.data.contents[0].m_img_attr}
                  /> */}
                      </span>
                      <div className="spotProgramCont">
                        <strong className="spotProgram-Title" style={{ whiteSpace: 'pre-line', height: '100' }}>{props.data.contents[0].title}</strong>
                      </div>
                    </a>
                  </a>
                </>
              )
            }
          </div>
          {/* <!-- 자유형 : type1 : 배너타입 --> */}
          <div className={`spotModuleWrap_freeType1-1 spotModuleWrap_ContentPhoto ${props.data.contents[1].title == '' || props.data.contents[1].title == null ? 'spotModuleWrap_freeTypeBnr' : ''}`}>
            {
              props.data.contents[1].link_url == null || props.data.contents[1].link_url == ''
                ? (
                  <>
                    <div className="spotModuleLink">
                      <span className="spotModuleImage_w">
                        <img src={props.data.contents[1].m_img_url}
                          className="spotModuleImg" alt={props.data.contents[1].m_img_attr} />
                        {/* <Image
                    src={props.data.contents[1].m_img_url}
                    className="spotModuleImg"
                    layout='fixed'
                    width={335}
                    height={121}
                    quality={props.data.contents[1].imageQuality || 75}
                    alt={props.data.contents[1].m_img_attr}
                  /> */}
                      </span>
                      <div className="spotProgramCont">
                        <strong className="spotProgram-Title" style={{ whiteSpace: 'pre-line' }}>{props.data.contents[1].title}</strong>
                      </div>
                    </div>
                  </>
                )
                :
                (
                  <>
                    <a href={props.data.contents[1].link_url}>
                      <a onClick={(e) => handleClick(e, props.data.contents[1], '3free','2')} target={props.data.contents[1].link_new_yn === 'Y' ? '_blank' : ''} className="spotModuleLink">
                        <span className="spotModuleImage_w">
                          <img src={props.data.contents[1].m_img_url}
                            className="spotModuleImg" alt={props.data.contents[1].m_img_attr} />
                          {/* <Image
                    src={props.data.contents[1].m_img_url}
                    className="spotModuleImg"
                    layout='fixed'
                    width={335}
                    height={121}
                    quality={props.data.contents[1].imageQuality || 75}
                    alt={props.data.contents[1].m_img_attr}
                  /> */}
                        </span>
                        <div className="spotProgramCont">
                          <strong className="spotProgram-Title" style={{ whiteSpace: 'pre-line' }}>{props.data.contents[1].title}</strong>
                        </div>
                      </a>
                    </a>
                  </>
                )
            }

          </div>
          {/* <div className="spotModuleWrap_freeType1-1 spotModuleWrap_freeTypeBnr spotModuleWrap_ContentPhoto">
            <Link href={getClickLinkParams(props.data.contents[1].link_url, props.clickParams)} >
              <a href={props.data.contents[1].link_url} className="spotModuleLink">
                <Image
                  src={props.data.contents[1].m_img_url}
                  className="spotModuleImg"
                  layout='fixed'
                  width={335}
                  height={121}
                  quality={props.data.contents[1].imageQuality || 75}
                  alt={props.data.contents[1].m_img_attr}
                />
              </a>
            </Link>
          </div> */}

        </div>
      </div>
    </div >
  );
}
